//SET AUTHORIZED STATE

export const setAuthorizedState = (payload) => ({
    type : 'SET_AUTHORIZED_STATE',
    payload
});


// WEBPACK FOOTER //
// ./src/Actions/loginHandler.js